import type { ResultStatus } from "types/imageRecognition";
import type { SelfReportedResult } from "types/models";

export const isComparableModelResult = (modelResult: ResultStatus): boolean =>
  modelResult === "POSITIVE" || modelResult === "NEGATIVE";

export const isSelfReportMatchingModel = (
  selfReportedResult: SelfReportedResult,
  modelResult: ResultStatus,
): boolean =>
  (selfReportedResult === "positive" && modelResult === "POSITIVE") ||
  (selfReportedResult === "negative" && modelResult === "NEGATIVE");

/**
 * Mismatch confirmation is shown only when the model returned a definitive
 * positive/negative result that disagrees with the user's selection.
 */
export const shouldShowSelfReportMismatchDialog = (
  selfReportedResult: SelfReportedResult,
  modelResult: ResultStatus,
): boolean =>
  isComparableModelResult(modelResult) &&
  !isSelfReportMatchingModel(selfReportedResult, modelResult);
